import { el } from "../utils/dom.ts";

const KEY = "vb-disclaimer-ack";

// One-time modal on first visit. Financial-tool disclaimer (mandatory per plan).
export function showFirstVisitDisclaimer(): void {
  if (localStorage.getItem(KEY)) return;
  const overlay = el("div", { className: "disclaimer-overlay" }, [
    el("div", { className: "disclaimer-modal" }, [
      el("h2", {}, ["Trước khi bắt đầu"]),
      el("p", {}, [
        "My Vietnam Beat là công cụ tham khảo tổng hợp từ tin tức và dữ liệu công khai. ",
        "Đây ", el("strong", {}, ["không phải khuyến nghị đầu tư"]), ". ",
        "Dữ liệu giá có độ trễ và có thể sai lệch. Luôn kiểm chứng với nguồn chính thức trước khi ra quyết định tài chính.",
      ]),
      el(
        "button",
        {
          className: "disclaimer-ok",
          onclick: () => {
            localStorage.setItem(KEY, "1");
            overlay.remove();
          },
        },
        ["Tôi hiểu"],
      ),
    ]),
  ]);
  document.body.append(overlay);
}
